<template>
	<div class="top-bar">
		<div class="logo-w menu-size">
			<a class="logo">
				<img src="/img/sb-logo-dark-icon.svg" class="logo-sb" />
			</a>
		</div>

		<div class="fancy-selector-w" v-if="final_open_sessions.length > 0">
			<div class="fancy-selector-current">
				<div class="fs-img">
					<i class="fal" :class="'icon-'+selectedSession.session_type" style="font-size: 30px;"></i>
				</div>
				<div class="fs-main-info text-black">
					<div class="fs-name">Session {{selectedSession.id_session}}</div>
					<div class="fs-sub text-black">
						<span>Type:</span>
						<strong class="text-black">{{selectedSession.session_type | capitalize}}</strong>
					</div>
				</div>
				<div class="fs-extra-info">
					<strong>{{selectedSession.products_count}}</strong>
					<span>Items</span>
				</div>
				<div class="fs-selector-trigger" @click.prevent="toggleSessionDrawer">
					<i class="os-icon os-icon-arrow-down4"></i>
				</div>
			</div>
			<div class="fancy-selector-options">
				<div class="fancy-selector-option active" v-for="(item, index) in final_open_sessions" @click.prevent="redirectOpenSession(item)">
					<div class="fs-img">
						<i class="fal" :class="'icon-'+item.session_type" style="color:#fff; font-size: 30px;"></i>
					</div>
					<div class="fs-main-info">
						<div class="fs-name">Session {{item.id_session}}</div>
						<div class="fs-sub">
							<span>Type:</span>
							<strong>{{item.channel | capitalize }} {{item.type || item.shoot_type | capitalize}}</strong>
						</div>
					</div>
					<div class="fs-extra-info">
						<strong>{{item.products_count}}</strong>
						<span>Items</span>
					</div>
				</div>
				<!-- <div class="fancy-selector-actions text-right">
					<a class="btn btn-primary" href="#">
						<i class="os-icon os-icon-ui-22"></i>
						<span>Add Session</span>
					</a>
				</div> -->
			</div>
		</div>

		<div class="top-menu-controls">
			<!-- <div class="element-search autosuggest-search-activator">
				<input placeholder="Start typing to search..." type="text" class="search-bar" />
			</div> -->
			<div class="client-details">
				<strong style="color: #047bf8;">{{clientDetails.display_name_en }} -- {{defaultLocation && defaultLocation.name_en}}</span></span></strong>
			</div>

			<div class="messages-notifications os-dropdown-trigger os-dropdown-position-left">
				<i class="os-icon os-icon-mail-14"></i>
				<div class="new-messages-count" v-if="notifications && notifications.length">
					{{notifications && notifications.length || 0}}
				</div>
				<div class="os-dropdown light message-list">
					<ul v-if="notifications.length > 0">
						<li v-for="notification in notifications">
							<a @click="getNotificationPath(notification)">
								<div class="user-avatar-w">
									<img alt="" :src="notification.avatar">
								</div>
								<div class="message-content">
									<h6 class="message-from">
										{{notification.name}}
									</h6>
									<h6 class="message-title">
										{{notification.body}}
									</h6>
								</div>
							</a>
						</li>
					</ul>
					<ul v-else>
						<li>
							<a >
								<div class="message-content" style="color: #047bf8;">
									You have no new notifications
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="logged-user-w">
				<div class="logged-user-i">
					<div class="avatar-w">
						<img alt="" :src="user.avatar">
					</div>
					<div class="logged-user-menu color-style-bright">
						<div class="logged-user-avatar-info">
							<div class="avatar-w">
								<img alt="" :src="user.avatar">
							</div>
							<div class="logged-user-info-w">
								<div class="logged-user-name">
									{{user.name}}
								</div>
								<div class="logged-user-role">
									Administrator
								</div>
							</div>
						</div>
						<div class="bg-icon">
							<i class="os-icon os-icon-wallet-loaded"></i>
						</div>
						<ul>
							<!-- <li>
								<a><i class="os-icon os-icon-user-male-circle2"></i><span>Profile Details</span></a>
							</li>
							<li>
								<a><i class="os-icon os-icon-others-43"></i><span>Notifications</span></a>
							</li> -->
							<li>
								<a @click.prevent="handleLogOut">
									<i class="os-icon os-icon-signs-11"></i>
									<span>Logout</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
  props: ['user', 'openSessions', 'currentRoute'],
  data: function () {
    return {
	  originalWidth: 0,
	  final_open_sessions: [],
	  selectedSession: ''
    }
  },
  mounted () {
    var self = this
    var channel = this.$pusher.subscribe('user')
    channel.bind('notification', function (data) {
	    if (parseInt(data.id_user) == parseInt(self.user.id_user)) {
		  self.handleNotification(data)
		  self.refreshTopbar()
	    }
    })
    this.formatOpenSessions()

	$('.os-dropdown-trigger').on('mouseenter', function () {
		$(this).addClass('over');
	});
	$('.os-dropdown-trigger').on('mouseleave', function () {
		$(this).removeClass('over');
	});
  },
  methods: {
    handleNotification (data) {
      this.$vs.notify({
        time: data.time,
        position: data.position,
        title: data.title,
        text: data.text,
        color: data.color
      })
    },
    refreshTopbar () {
      var self = this
      this.$http.get('/auth/profile')
        .then(function (response) {
          self.$store.dispatch('updateUser', response.data)
          self.$store.dispatch('updateOpenSessions', response.data.open_sessions)
          self.$store.dispatch('updateClientVariables', response.data.variables)
        })
    },
    handleLogOut: function () {
	  localStorage.removeItem('token')
	  this.$store.dispatch('logoutUser')
	  this.$router.replace('/')
	  this.$router.push('/login')
    },
    toggleSessionDrawer: function () {
	  $('.fs-selector-trigger')
        .closest('.fancy-selector-w')
        .toggleClass('opened')
    },
    redirectOpenSession: function (session) {
      this.selectedSession = session

      this.$router.push(session.redirect_to)

      $('.fs-selector-trigger')
        .closest('.fancy-selector-w')
        .toggleClass('opened')
    },
    formatAvatar: function (user) {
	  return 'http://52.66.102.131/' + user.avatar
    },
    formatOpenSessions: function () {
	  var self = this

	  self.final_open_sessions = []

	  var photodesk_sessions = self.openSessions.photodesk_sessions
	  var retouchdesk_sessions = self.openSessions.retouchdesk_sessions
	  var pretouchdesk_sessions = self.openSessions.pretouchdesk_sessions
	  var copydesk_sessions = self.openSessions.copydesk_sessions

	  if (photodesk_sessions && photodesk_sessions.id_session !== null) {
        self.final_open_sessions.push(photodesk_sessions)
	  }
	  if (pretouchdesk_sessions && pretouchdesk_sessions.id_session !== null) {
        self.final_open_sessions.push(pretouchdesk_sessions)
	  }
	  if (retouchdesk_sessions && retouchdesk_sessions.id_session !== null) {
        self.final_open_sessions.push(retouchdesk_sessions)
	  }
	  if (copydesk_sessions && copydesk_sessions.id_session !== null) {
        self.final_open_sessions.push(copydesk_sessions)
	  }

      for (let i = 0; i < self.final_open_sessions.length; i++) {
        var s = self.final_open_sessions[i]
        s['redirect_to'] = self.getRedirectPath(s)
	  }

	  if (self.selectedSession == '' || self.selectedSession == null) {
        self.selectedSession = self.final_open_sessions[0]
	  }
	  self.getActiveSessionPage(self.$route.path)
    },
    getRedirectPath (session) {
      if (session && session.session_type == 'copydesk') {
        return '/' + session.session_type + '/sessions/' + session.type + '/' + session.id_session
      } else {
        return '/' + session.session_type + '/sessions/' + session.id_session
      }
    },
    getNotificationPath (notification) {
	 // mark the notification as read
	 this.markRead(notification)
	 if (notification.path !== null && notification.path != '') {
        this.$router.push(notification.path)
	  } else {
        this.$router.push({ name: 'productdesk-product-view', params: { id_product: (notification && notification.id_product) } })
	  }
    },
    markRead (notification) {
      var self = this
      let url = '/auth/notification/update'
      let data = {
        id_product_comment: notification.id_product_comment
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.refreshTopbar()
        })
    },
    getActiveSessionPage (path) {
	  var self = this
      for (let i = 0; i < self.final_open_sessions.length; i++) {
        var s = self.final_open_sessions[i]
        if (path == s.redirect_to) {
          self.selectedSession = s
        }
	  }
    }
  },
  computed: {
    notifications () {
	  return this.$store.getters.authNotifications
    },
    clientDetails () {
	  return this.$store.getters.clientDetails
    },
    defaultLocation () {
	  	var locations = this.$store.getters.clientLocations
		if(typeof(locations) == 'object') {
			let location = locations.find(loc => loc.is_default === 1)
			return location
		}
		return {}
	}
  },
  watch: {

    $route (to, from) {
      this.getActiveSessionPage(to.path)
    },
    openSessions () {
	  this.formatOpenSessions()
    }
  },
  filters: {
    capitalize: function (value) {
	  if (!value) return ''
	  value = value.toString()
	  return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style scoped>
.bg-gray {
	background: #f2f4f8;
	border-right:
}
.logo-sb {
  height: 32px !important;
  width: auto !important;
}

.icon-photodesk::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f332";
}

.icon-retouchdesk::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f1fc";
}

.icon-pretouchdesk::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f058";
}

.icon-copydesk::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f044";
}
.top-bar .logged-user-w .avatar-w img {
  width: 35px;
}
.client-details strong {
	color: #fff;
	padding-right: 10px;
}

.client-details {
	border-right: 1px solid #fff;

}
</style>
